import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateIsChecked extends ValidateDefaults {
    constructor(obj) {
        obj = obj ? obj : {};
        super(obj);
        this.message = obj.message ? obj.message : 'Required';
        this.on = obj.on && Array.isArray(obj.on) ? obj.on : ['change'];
    }

    validate(bool) {
        if (!bool) {
            return false;
        }
        return bool;
    }
}
